import { AssetAttachmentService as OvermapAssetAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetAttachmentService extends OvermapAssetAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
